import React from 'react'
import { Modal, Typography, Icon, CircularProgress } from '@ann/web-components';
import {
	ModalHeaderContainer,
	CustomModalContainer,
	CustomModalContentContainer,
	DocumentWrapper
} from './Modals.styled';
import { useStore } from '../../../../../../../hooks'
import { useParams } from 'react-router-dom';


const AddFilesConfirmationModal = ({ isOpen, onClose, selectedDrives = [], selectedDocuments = [], isLoading }) => {
	const { agentId } = useParams();

	const { knowledgeStore, authStore } = useStore();


	const handleConfirmData = async () => {

		try {
			const result = await knowledgeStore.onGrantAccess({
				agentId: agentId,
				userId: authStore.userId,
			});

			if (result.success) {
				// Show success alert
				knowledgeStore.showAlert({
					severity: "success",
					description: `Successfully granted access to ${result.successCount} items`,
					autoClose: true,
					autoCloseDelay: 3000
				});
			} else {
				// Show error alert with all error messages
				const errorMessage = result.errorMessages.join('\n');
				knowledgeStore.showAlert({
					severity: "error",
					description: `Some items failed to be assigned:\n${errorMessage}`,
					autoClose: false
				});
			}

			onClose();
		} catch (error) {
			// Show generic error alert
			knowledgeStore.showAlert({
				severity: "error",
				description: "An unexpected error occurred while granting access",
				autoClose: false
			});
		} finally {
			knowledgeStore.clearDriveSelections();
			knowledgeStore.clearDocumentSelections();
			onClose();
		}

	}


	const handleCancel = () => {		
		onClose();
	}

	// Combine drives and documents for display
	const allSelectedItems = [
		...selectedDrives.map(drive => ({
			title: drive.name,
			icon: 'folder',
			type: 'drive'
		})),
		...selectedDocuments.map(document => ({
			title: document.name,
			icon: 'description',
			type: 'document'
		}))
	];

	return (

		<CustomModalContainer>
			<Modal isOpen={isOpen} onClose={handleCancel} size="medium" width="618px">
				<Modal.Header />
				<ModalHeaderContainer>
					<Typography category="title" size="medium" weight="bold">
						You're about to add these files to this agent. Continue?
					</Typography>
				</ModalHeaderContainer>
				<Modal.Body>
					{
						isLoading ? (
							<CircularProgress size="xl" />
						) : (
							<CustomModalContentContainer>
								{allSelectedItems.length > 0 ? (
									allSelectedItems.map((item, index) => (
										<DocumentWrapper key={`${item.type}-${index}`}>
											<Icon name={item.icon} />
											<Typography category="body" size="medium" weight="regular" color="body">
												{item.title}
											</Typography>
										</DocumentWrapper>
									))
								) : (
									<Typography category="body" size="medium" weight="regular" color="body">
										No items selected
									</Typography>
								)}
							</CustomModalContentContainer>
						)
					}

				</Modal.Body>
				<Modal.Actions align="center">
					<Modal.Button label="Cancel" onClick={handleCancel} type="secondary" disabled={isLoading} />
					<Modal.Button
						label="Yes, continue"
						onClick={handleConfirmData}
						disabled={allSelectedItems.length === 0 || isLoading}
					/>
				</Modal.Actions>
			</Modal>
		</CustomModalContainer>
	)
}

export default AddFilesConfirmationModal
